import useTypedContext from "hooks/useTypedContext";
import useAacFlags from "hooks/useAacFlags";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, NO_ACCESS_MESSAGE, hasAllRequiredActionsInAnySpace } from "utils/access";
import { Action } from "types/generated";
import { SpacesContext } from "views/Account/SpacesProvider";

/**
 * Hook that returns whether current user can create blueprint
 * When customAccessRoles flag is off: user needs to be admin, have root space admin access, or have manageable spaces
 * When customAccessRoles flag is on: user needs to be an admin or have SpaceAdmin action in at least one space
 * @returns {AccessResult} Object indicating if user can create blueprint and a message if not
 */
const useCanCreateBlueprint = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);
  const { customAccessRoles } = useAacFlags();
  const spacesContext = useTypedContext(SpacesContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = customAccessRoles
    ? hasAllRequiredActionsInAnySpace([Action.SpaceAdmin], viewer)
    : spacesContext.hasEntityCreateAccess;

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateBlueprint;
